import { Component, Inject, Input, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DialogData } from '../shared/model-service';

@Component({
  selector: 'app-dialog',
  templateUrl: './dialog.component.html',
  styleUrls: ['./dialog.component.css']
})
export class DialogComponent implements OnInit {
  //@Input() popup : Popup;
  constructor(@Inject(MAT_DIALOG_DATA) public data:DialogData) {
   }

  ngOnInit(): void {
  }

}
